export const TOKEN = "token";
export const LOGOUT_TIMEOUT_MS = 3000;
// sessionStorage flag: set when the session ended (401 without a message), read once by the start page
export const SESSION_ENDED = "sessionEnded";
// sessionStorage flag: set when a login link from support didn't work, read once by the start page
export const LOGIN_LINK_FAILED = "loginLinkFailed";
export const googleMapsApiKey = "AIzaSyCIPAaUGJG8JA0n8WtDaLZlASE7WbjCgAQ";

// statuses of a request to join an organization (OrganizationJoinRequests)
export const joinRequestStatuses = {
  ACTIVE: "active",
  ACCEPTED: "accepted",
  DENIED: "denied",
  WITHDRAWN: "withdrawn",
};

export const roles = {
  ADMIN: "admin",
  OWNER: "owner",
  MEMBER: "member",
};

export const subscriptionRoles = {
  BUYER: "USER_ROLE_SUB_05_BUYER",
  VIEWER: "USER_ROLE_SUB_05_VIEWER",
  TENDERER: "USER_ROLE_SUB_05_TENDERER",
  CUSTOMER: "USER_ROLE_SUB_05_CUSTOMER",
};
